export const DATES = "dates";
export const STATUS_FILTER = "status";
export const AGENT_TYPE = "agent_type";
export const ACTIVE_ONLY = "active_only";
